import React from "react";

const sizeMap = {
  sm: "h-4 w-4 border-2",
  md: "h-8 w-8 border-2",
  lg: "h-12 w-12 border-4",
};

const Spinner = ({ size = "md", className = "" }) => (
  <div
    className={`inline-block animate-spin rounded-full border-brand border-t-transparent ${sizeMap[size]} ${className}`}
    role="status"
    aria-label="Loading"
  />
);

export default Spinner;
